/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model', 'benchLocation'];
const factory = function (Model, benchLocation) {
  class Invoice extends Model {
    static initClass() {
      this.prototype.clientId = null;
      this.prototype.$resource = 'billing';
      this.prototype.$idName = 'id';
    }

    $fetch() {}
    $serialize(data) {
      return Object.assign({ chargeDate: data.invoiceDate }, data);
    }

    $download(invoice, clientId) {
      if (invoice.billingSystem === 'new') {
        return benchLocation.openRoot(`/billing/page/clients/${clientId}/invoices/${invoice.id}`);
      }
      return benchLocation.openRoot(`/invoice/${invoice.id}`);
    }
  }
  Invoice.initClass();

  return Invoice;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.invoice', moduleDeps).factory('Invoice', factory);
